import { render, staticRenderFns } from "./MenuItemForm.vue?vue&type=template&id=53bff478&scoped=true"
import script from "./MenuItemForm.vue?vue&type=script&lang=js"
export * from "./MenuItemForm.vue?vue&type=script&lang=js"
import style0 from "./MenuItemForm.vue?vue&type=style&index=0&id=53bff478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bff478",
  null
  
)

export default component.exports